import styles from "./index.less";

export default function Divider({ text }: { text: string }) {
  return <div className={styles.box}>{text}</div>;
}
